<template>
  <a-config-provider :locale="locale">
    <a-layout style="min-height: 100vh;height: 100%;">
      <a-layout-sider width="248" v-model:collapsed="collapsed" :trigger="null" collapsible>
        <div class="logo"><img src="~@/assets/logo.png" style="width: 100%; height:64px;" /> </div>
        <a-menu v-model:openKeys="openMenuKeys" v-model:selectedKeys="activeMenuKeys" @openChange="openChange"
          theme="dark" mode="inline" :style="{ lineHeight: '64px', height: '100%', borderRight: 0 }"
          :inline-collapsed="statecollapsed">
          <template v-for="menu in mainMenus">
            <a-sub-menu v-if="menu.children?.length > 0" :key="menu.key">
              <template #title>
                <BarChartOutlined v-if="menu.key == '0'" />
                <UnorderedListOutlined v-if="menu.key == '1'" />
                <SwapOutlined v-if="menu.key == '2'" />
                <MoneyCollectOutlined v-if="menu.key == '3'" />
                <AccountBookOutlined v-if="menu.key == '4'" />
                <FileOutlined v-if="menu.key == '5'" />
                <UserOutlined v-if="menu.key == '6'" />
                <SolutionOutlined v-if="menu.key == '7'" />
                <span>{{ menu.title }}</span>
              </template>
              <a-menu-item v-for="menusub in menu.children" :key="menusub.key" @click="redirectTo(menusub.url)">
                <RightCircleOutlined />
                <span>{{ menusub.title }}</span>
              </a-menu-item>
            </a-sub-menu>
            <a-menu-item v-else @click="redirectTo(menu.url)" :key="menu.key">
              <BarChartOutlined v-if="menu.key == '0'" />
              <UnorderedListOutlined v-if="menu.key == '1'" />
              <SwapOutlined v-if="menu.key == '2'" />
              <MoneyCollectOutlined v-if="menu.key == '3'" />
              <AccountBookOutlined v-if="menu.key == '4'" />
              <FileOutlined v-if="menu.key == '5'" />
              <UserOutlined v-if="menu.key == '6'" />
              <SolutionOutlined v-if="menu.key == '7'" />
              <span>{{ menu.title }}</span>
            </a-menu-item>
          </template>
        </a-menu>
      </a-layout-sider>
      <a-layout>
        <a-layout>
          <a-layout-header style="background: #f2f2f2; padding: 0">
            <menu-unfold-outlined v-if="collapsed" class="trigger" @click="() => (collapsed = !collapsed)" />
            <menu-fold-outlined v-else class="trigger" @click="() => (collapsed = !collapsed)" />
            <div class="subtitle">
              <h2>{{ currentMenu.title }}</h2>
            </div>
            <div class="avatar">
              <a-avatar :size="35" style="background:#1990FF;">
                <template #icon>
                  <UserOutlined />
                </template>
              </a-avatar>
              <span class="loginname"> {{ username }} </span>
            </div>
            <div class="setting">
              <a-card title="账号管理">
                <a-card-grid style="width: 100%; text-align: center; cursor: pointer" @click="showReset">
                  修改密码
                </a-card-grid>
              </a-card>
              <a-card title="其他服务">
                <a-card-grid style="width: 100%; text-align: center; cursor: pointer" @click="logout">
                  退出登录
                </a-card-grid>
              </a-card>
            </div>
          </a-layout-header>
          <a-layout-content :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '580px', }">
            <router-view v-slot="{ Component, route }">
              <keep-alive>
                <component :key="route.name" :is="Component" />
              </keep-alive>
            </router-view>
          </a-layout-content>
        </a-layout>
      </a-layout>
    </a-layout>
    <a-modal v-model:visible="resetModal" title="修改密码" @ok="resetPwd" @cancel="cancelSave" ok-text="确认" cancel-text="取消"
      :confirm-loading="reseting" :cancel-button-props="{ disabled: reseting }" :maskClosable="false"
      :closable="!reseting">
      <a-form ref="formRef" name="resetForm" :model="resetForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }"
        autocomplete="off">
        <a-form-item label="新密码" name="password" :rules="$constant.password_rule">
          <a-input-password v-model:value="resetForm.password" placeholder="请输入新密码" :disabled="reseting">
            <template #prefix>
              <LockOutlined class="site-form-item-icon" />
            </template>
          </a-input-password>
        </a-form-item>
        <a-form-item label="确认密码" name="password2" :rules="[
          { required: true, message: '确认密码不能为空' },
          { validator: validatePass2, trigger: 'change' },
        ]">
          <a-input-password v-model:value="resetForm.password2" placeholder="请确认密码" :disabled="reseting">
            <template #prefix>
              <LockOutlined class="site-form-item-icon" />
            </template>
          </a-input-password>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-drawer width="640" placement="right" :closable="false" :visible="accountModal" @close="onClose">
      <p class="ptitle">商户信息</p>
      <a-descriptions title="基本信息">
        <a-descriptions-item label="账号">Zhou Maomao</a-descriptions-item>
        <a-descriptions-item label="公司名称">Zhou Maomao</a-descriptions-item>
        <a-descriptions-item label="联系人">Zhou Maomao</a-descriptions-item>
        <a-descriptions-item label="联系电话">18512345678</a-descriptions-item>
      </a-descriptions>
      <a-divider />
      <a-descriptions title="授信额度(CNY)">
        <a-descriptions-item>
          <a-statistic :precision="2" :value="1000000" />
        </a-descriptions-item>
      </a-descriptions>
      <a-divider />
      <a-descriptions title="营业执照">
        <a-descriptions-item>
          <img src="~@/assets/login_bg.jpg" style="height:168px; padding-top:10px;" />
        </a-descriptions-item>
      </a-descriptions>
      <a-divider />
      <a-descriptions title="征信截图">
        <a-descriptions-item>
          <img src="~@/assets/login_bg.jpg" style="height:168px; padding-top:10px;" />
        </a-descriptions-item>
      </a-descriptions>
      <a-descriptions title="电子合同">
        <a-descriptions-item>
          <a-list size="large" :data-source="filedata" style="width:100%;">
            <template #renderItem="{ item }">
              <a-list-item>
                {{ item.name }}
                <template #actions>
                  <a key="list-loadmore-edit">下载预览</a>
                </template>
              </a-list-item>
            </template>
          </a-list>
        </a-descriptions-item>
      </a-descriptions>
    </a-drawer>
  </a-config-provider>
</template>
<script setup>
import {
  UserOutlined,
  SolutionOutlined,
  LockOutlined,
  SwapOutlined,
  UnorderedListOutlined,
  MoneyCollectOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  RightCircleOutlined,
  BarChartOutlined,
  FileOutlined,
  AccountBookOutlined,
} from "@ant-design/icons-vue";
import locale from "ant-design-vue/es/locale/zh_CN";
import "dayjs/locale/zh-cn";
import { computed, watch, ref, getCurrentInstance, } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { Modal, message } from "ant-design-vue";

const { proxy } = getCurrentInstance();
const formRef = ref();

const store = useStore();
const route = useRoute();
const router = useRouter();

const mainMenus = ref([]);
const openMenuKeys = ref([]);
const activeMenuKeys = ref([]);
const currentMenu = ref({});
const resetForm = ref({});
const resetModal = ref(false);
const accountModal = ref(false);
const reseting = ref(false);
const collapsed = ref(false);
const statecollapsed = ref(true);

const username = computed(() => store.state.user.username);
const name = computed(() => store.state.user.name);

watch(() => route.path, (new_path) => {
  mainMenus.value = store.getters["menu/getMenus"](new_path);
  activeMenuKeys.value = store.getters["menu/getActiveMenuKeys"](mainMenus.value);
  currentMenu.value = store.getters["menu/getCurrentMenu"](mainMenus.value, new_path);
  let parentMenu = store.getters["menu/getParentMenu"](mainMenus.value, new_path);
  openMenuKeys.value.push(parentMenu.key);
}, { immediate: true });

const redirectTo = (url) => {
  router.push({ path: url }).catch(console.error);
};
const logout = () => {
  localStorage.clear();
  router.replace({ path: "/login" }).catch(console.error);
};
const validatePass2 = async (_rule, value) => {
  if (!value) {
    return Promise.resolve();
  } else if (value !== resetForm.value.password) {
    return Promise.reject("两次输入密码不一致");
  } else {
    return Promise.resolve();
  }
};
const showReset = () => {
  resetForm.value = { password: "", password2: "", };
  resetModal.value = true;
};
const resetPwd = async () => {
  try {
    await formRef.value.validateFields();
    reseting.value = true;
    proxy.$api.doAPI("/resetpwd", { resetForm: resetForm.value, }).then((res) => {
      reseting.value = false;
      if (res.code === 0) {
        resetModal.value = false;
        Modal.success({
          title: "提示", content: "修改成功，重新登录",
          onOk() {
            logout();
          },
        });
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      reseting.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
};
const cancelSave = () => {
  console.log('cancelSave');
  formRef.value.clearValidate();
  resetModal.value = false;
}
const openChange = (openKeys) => {
  console.log('openChange', openKeys);
  openMenuKeys.value = openKeys;
}
const onClose = () => {
  accountModal.value = false;
};
const filedata = [
  { id: 1, name: '2023.07.22 借款合同.docx' },
  { id: 2, name: '2023.07.22 担保合同.docx' },
];
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
}

:deep(.ant-layout) {
  background: #fff;
}

.logo {
  height: 35px;
  margin: 16px 24px 16px 0;
  color: #fff;
  display: flex;
  font-size: 24px;
  font-weight: 800;
  align-items: center;
  justify-content: center;
}

.ant-menu-dark.ant-menu-horizontal {
  flex: 1;
}

.site-layout-background {
  background: #fff;
}

.avatar {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-right: 10px;
}

.loginname {
  font-size: 16px;
  margin-left: 5px;
}

.setting {
  display: none;
  box-shadow: 0 0 5px #bbb;
  position: absolute;
  top: 65px;
  right: 0;
  background: #ccc;
  z-index: 10;
}

.setting:hover {
  display: block;
}

.avatar:hover+.setting {
  display: block;
}

.trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

.trigger:hover {
  color: #1890ff;
}

.subtitle {
  display: flex;
  flex: 1;
  align-items: center;

  h2 {
    margin-bottom: 5px;
  }
}

.footer {
  position: fixed;
  bottom: 50px;
  border-top: 1px solid #fff;
  width: 100%;
}

.ptitle {
  font-size: 20px;
  color: #333;
}
</style>
